export const allData = [
  {
    id: 1,
    name: "Vera",
    title: "So, who am I?",
    description: "I'm Vera, I know who I am. But it is still for you to find out.",
    url: "./images/vera-color.jpeg",
  },

  {
    id: 2,
    name: "Vera, young",
    title: "I can feel it!",
    description: "I was once little and on the way",
    url: "./images/vera-boat.jpeg",
  },

  {
    id: 3,
    name: "Vera is sceptic",
    title: "I mean, wtf?",
    description: "To be written",
    url: "./images/vera-sceptic.jpeg",
  },

  {
    id: 4,
    name: "Grandpa",
    title: "I'm so colorful!",
    description: "To be written",
    url: "./images/vera-grandpa.jpeg",
  },

  {
    id: 5,
    name: "Boy",
    title: "That is a great hat!",
    description: "To be written",
    url: "./images/vera-boy.jpeg",
  },

  {
    id: 6,
    name: "Vera and the gang",
    title: "Who run the world?",
    description: "To be written",
    url: "./images/vera-gang.jpeg",
  },

  {
    id: 7,
    name: "Vera and family",
    title: "Oh family!",
    description: "To be written",
    url: "./images/vera-fam.jpeg",
  },
];
